// import React, { useEffect, useState } from "react";
// import { Col, Table, Spinner, Badge, Row, Form } from "react-bootstrap";
// import { useNavigate, useParams } from "react-router-dom";
// import axios from "axios";
// import { authHeader } from "../../../services/auth-header";
// import { BASE_URL } from "../../../services/Api";
// import Swal from "sweetalert2";

// const ViewPumpInternationalSalesOrder = () => {
//   const navigate = useNavigate();
//   const { id } = useParams();
//   const [isLoading, setIsLoading] = useState(true);
//   const [salesOrderData, setSalesOrderData] = useState(null);
//   const [exportchargescurrency, setExportchargescurrency] = useState(0);
//   const [rows, setRows] = useState([]);

//   const fetchSalesOrderData = async () => {
//     try {
//       const response = await axios.get(`${BASE_URL}salesOrder/findById/${id}`, {
//         headers: authHeader()
//       });

//       const data = response.data;
//       setSalesOrderData(data);
//       setExportchargescurrency(data.exportpreperationchargescurrency || 0);

//       if (data.salesOrderItems && data.salesOrderItems.length > 0) {
//         setRows(data.salesOrderItems.map(item => ({
//           description: item.product?.description || '',
//           productremarks: item.productremarks || "",
//           quantity: item.quantity,
//           unitratecurrency: item.unitratecurrency,
//           totalcurrency: item.totalcurrency,
//           exchangerate: item.exchangerate,
//           unitRateInr: item.unitrateinr,
//           totalInr: item.totalinr,
//           hsnsacno: item.hsnsacno,
//           partno: item.partno,
//           serialnumber: item.serialnumber,
//           modelnumber: item.modelnumber,
//           tagnumber: item.tagnumber,
//           moc: item.moc || "",
//           itemcode: item.itemcode || "",
//           uom: item.uom,
//           currency: item.currency || ""
//         })));
//       }
//     } catch (error) {
//       console.error("Error fetching sales order data", error);
//       Swal.fire({
//         icon: "error",
//         title: "Error",
//         text: "Failed to fetch sales order data. Please try again.",
//       });
//       navigate("/salesOrderIndexTable/1");
//     } finally {
//       setIsLoading(false);
//     }
//   };

//   useEffect(() => {
//     fetchSalesOrderData();
//   }, [id]);

//   const formatDate = (dateString) => {
//     if (!dateString) return '-';
//     const date = new Date(dateString);
//     return date.toLocaleDateString('en-GB');
//   };

//   const getStatusBadge = (status) => {
//     switch (status) {
//       case 'Draft':
//         return 'secondary';
//       case 'Submitted':
//         return 'primary';
//       case 'Approved':
//         return 'success';
//       case 'Rejected':
//         return 'danger';
//       case 'Completed':
//         return 'info';
//       case 'Open':
//         return 'warning';
//       default:
//         return 'light';
//     }
//   };

//   if (isLoading) {
//     return (
//       <div className="container text-center py-5">
//         <Spinner animation="border" />
//         <p>Loading sales order details...</p>
//       </div>
//     );
//   }

//   if (!salesOrderData) {
//     return (
//       <div className="container text-center py-5">
//         <p>No sales order data found</p>
//       </div>
//     );
//   }

//   return (
//     <div className="container">
//       <br />
//       <h5>International Pump Sales Order Details</h5>
//       <hr />
//       <Form>
//         {/* Header Information */}
//         <Row>
//           <Col md={6}><p><strong>Sales Order No:</strong> {salesOrderData.sono || '-'}</p></Col>
//           <Col md={6}><p><strong>Sales Order Date:</strong> {formatDate(salesOrderData.sodate)}</p></Col>
//           <Col md={6}><p><strong>Quotation No:</strong> {salesOrderData.quotationno || '-'}</p></Col>
//           <Col md={6}><p><strong>Quotation Date:</strong> {formatDate(salesOrderData.quotationdate)}</p></Col>
//           <Col md={6}><p><strong>Status:</strong> <Badge bg={getStatusBadge(salesOrderData.status)}>{salesOrderData.status || '-'}</Badge></p></Col>
//           <Col md={6}><p><strong>Currency:</strong> {salesOrderData.salesordercurrency || '$ (USD)'}</p></Col>
//           <Col md={6}><p><strong>Exchange Rate:</strong> {salesOrderData.soexchangerate || '0.00'}</p></Col>
//           <Col md={6}><p><strong>Customer PO No:</strong> {salesOrderData.customerpono || '-'}</p></Col>
//           <Col md={6}><p><strong>Customer PO Date:</strong> {formatDate(salesOrderData.customerpodate)}</p></Col>
//           <Col md={6}><p><strong>Branch:</strong> {salesOrderData.branch?.branchname || '-'}</p></Col>
//           <Col md={6}><p><strong>Warehouse:</strong> {salesOrderData.warehouse?.warehousename || '-'}</p></Col>
//         </Row>

//         <hr />
//         <h5>Customer Details</h5>  
//         <hr />
//         <Row>
//           <Col md={6}><p><strong>Customer:</strong> {salesOrderData.customer?.companyname || '-'}</p></Col>
//           <Col md={6}><p><strong>Contact Person:</strong> {salesOrderData.contactperson || '-'}</p></Col>
//           <Col md={6}><p><strong>Contact No:</strong> {salesOrderData.contactno || '-'}</p></Col>
//           <Col md={6}><p><strong>Email:</strong> {salesOrderData.email || '-'}</p></Col>
//           <Col md={12}><p><strong>Customer Address:</strong> {salesOrderData.customeraddress?.customeraddress || '-'}</p></Col>
//         </Row>

//         <hr />
//         <h5>Terms</h5>
//         <hr />

//         <Row>
//           <Col md={6}><p><strong>Payment Terms:</strong> {salesOrderData.paymentterm || '-'}</p></Col>
//           <Col md={6}><p><strong>Incoterms:</strong> {salesOrderData.incoterm || '-'}</p></Col>
//         </Row>

//         <hr />
//         <h5>Branch and Warehouse Details</h5>
//         <hr />
//         <Row>
//           <Col md={6}><p><strong>Branch:</strong> {salesOrderData.branch?.branchname || '-'}</p></Col>
//           <Col md={6}><p><strong>Warehouse:</strong> {salesOrderData.warehouse?.warehousename || '-'}</p></Col>
//         </Row>
//         <hr />

//         <h5>Sales Order Items</h5>
//         <div className="table-responsive">
//           <Table striped bordered hover>
//             <thead>
//               <tr>
//                 <th>Product Description</th>
//                 <th>Serial No</th>
//                 <th>Model No</th>
//                 <th>Tag No</th>
//                 <th>Part No</th>
//                 <th>MOC</th>
//                 <th>Item Code</th>
//                 <th>HSN Code</th>
//                 <th>Quantity</th>
//                 <th>UOM</th>
//                 <th>Unit Price (Currency)</th>
//                 <th>Total (Currency)</th>
//                 <th>Unit Price (INR)</th>
//                 <th>Total (INR)</th>
//               </tr>
//             </thead>
//             <tbody>
//               {rows.map((row, index) => (
//                 <tr key={index}>
//                   <td>
//                     {row.description}
//                     {row.productremarks && (
//                       <div className="text-muted small mt-2">
//                         <strong>Remarks:</strong> {row.productremarks}
//                       </div>
//                     )}
//                   </td>
//                   <td>{row.serialnumber || '-'}</td>
//                   <td>{row.modelnumber || '-'}</td>
//                   <td>{row.tagnumber || '-'}</td>
//                   <td>{row.partno || '-'}</td>
//                   <td>{row.moc || '-'}</td>
//                   <td>{row.itemcode || '-'}</td>
//                   <td>{row.hsnsacno || '-'}</td>
//                   <td>{row.quantity || '0'}</td>
//                   <td>{row.uom || '-'}</td>
//                   <td>{row.unitratecurrency?.toFixed(2) || '0.00'}</td>
//                   <td>{row.totalcurrency?.toFixed(2) || '0.00'}</td>
//                   <td>{row.unitRateInr?.toFixed(2) || '0.00'}</td>
//                   <td>{row.totalInr?.toFixed(2) || '0.00'}</td>
//                 </tr>
//               ))}
//             </tbody>
//           </Table>
//         </div>

//         {/* Totals Card */}
//         <div className="card mt-3" style={{ width: '50%', marginLeft: 'auto' }}>
//           <div className="card-header bg-light">
//             <h5 className="mb-0">Sales Order Summary</h5>
//           </div>
//           <div className="card-body">
//             <div className="row mb-2">
//               <div className="col-8 text-end">
//                 <strong>Net Total (INR)</strong>
//               </div>
//               <div className="col-4">
//                 <strong>{salesOrderData.nettotalinr}</strong>
//               </div>
//             </div>

//             <div className="row mb-2">
//               <div className="col-8 text-end">
//                 <strong>Net Total (Currency)</strong>
//               </div>
//               <div className="col-4">
//                 <strong>{salesOrderData.nettotalcurrency}</strong>
//               </div>
//             </div>

//             <div className="row mb-2">
//               <div className="col-8 text-end">
//                 <strong>Export Charges (Currency)</strong>
//               </div>
//               <div className="col-4">
//                 <strong>{salesOrderData.exportpreperationchargescurrency?.toFixed(2) || '0.00'}</strong>
//               </div>
//             </div>

//             <div className="row mb-2">
//               <div className="col-8 text-end">
//                 <strong>Export Charges (INR)</strong>
//               </div>
//               <div className="col-4">
//                 <strong>{(salesOrderData.exportpreperationchargescurrency * salesOrderData.soexchangerate)?.toFixed(2) || '0.00'}</strong>
//               </div>
//             </div>

//             <div className="row mt-3 pt-2 border-top">
//               <div className="col-8 text-end">
//                 <h5>Grand Total (INR)</h5>
//               </div>
//               <div className="col-4">
//                 <h5>{salesOrderData.grandtotalinr?.toFixed(2) || '0.00'}</h5>
//               </div>
//             </div>

//             <div className="row mt-2">
//               <div className="col-8 text-end">
//                 <h5>Grand Total (Currency)</h5>
//               </div>
//               <div className="col-4">
//                 <h5>{salesOrderData.grandtotalcurrency?.toFixed(2) || '0.00'}</h5>
//               </div>
//             </div>
//           </div>
//         </div>

//         <div className="d-flex justify-content-end mt-4">
//           <button
//             className="btn btn-secondary"
//             type="button"
//             onClick={() => navigate("/salesOrderIndexTable/1")}
//           >
//             BACK TO LIST
//           </button>
//         </div>
//       </Form>
//     </div>
//   );
// };

// export default ViewPumpInternationalSalesOrder;





import React, { useEffect, useState } from "react";
import { Col, Table, Spinner, Badge, Row, Container, Button } from "react-bootstrap";
import { useNavigate, useParams } from "react-router-dom";
import axios from "axios";
import { authHeader } from "../../../services/auth-header";
import { BASE_URL } from "../../../services/Api";
import Swal from "sweetalert2";
import { FaArrowLeft } from "react-icons/fa";

const ViewPumpInternationalSalesOrder = () => {
  const navigate = useNavigate();
  const { id } = useParams();
  const [isLoading, setIsLoading] = useState(true);
  const [salesOrderData, setSalesOrderData] = useState(null);
  const [rows, setRows] = useState([]);

  const fetchSalesOrderData = async () => {
    try {
      const response = await axios.get(`${BASE_URL}salesOrder/findById/${id}`, {
        headers: authHeader()
      });

      const data = response.data;
      setSalesOrderData(data);

      if (data.salesOrderItems && data.salesOrderItems.length > 0) {
        setRows(data.salesOrderItems.map(item => ({
          description: item.product?.description || '',
          productremarks: item.productremarks || "",
          quantity: item.quantity,
          unitratecurrency: item.unitratecurrency,
          totalcurrency: item.totalcurrency,
          exchangerate: item.exchangerate,
          unitRateInr: item.unitrateinr,
          totalInr: item.totalinr,
          hsnsacno: item.hsnsacno,
          partno: item.partno,
          serialnumber: item.serialnumber,
          modelnumber: item.modelnumber,
          tagnumber: item.tagnumber,
          moc: item.moc || "",
          itemcode: item.itemcode || "",
          uom: item.uom,
          currency: item.currency || ""
        })));
      }
    } catch (error) {
      console.error("Error fetching sales order data", error);
      Swal.fire({
        icon: "error",
        title: "Error",
        text: "Failed to fetch sales order data. Please try again.",
      });
      navigate("/salesOrderIndexTable/1");
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    fetchSalesOrderData();
  }, [id]);

  const formatDate = (dateString) => {
    if (!dateString) return '-';
    const date = new Date(dateString);
    return date.toLocaleDateString('en-IN');
  };

  const formatCurrency = (value) =>
    new Intl.NumberFormat('en-IN', {
      style: 'currency',
      currency: 'INR',
      minimumFractionDigits: 2,
    }).format(value || 0);

  const formatNumber = (value) => {
    if (value === null || value === undefined || isNaN(value)) return '0.00';
    return parseFloat(value).toFixed(2);
  };

  const getAddressString = (address) => {
    if (!address) return '-';
    return [
      address.customeraddress,
      address.city?.cityname,
      address.state?.statename,
      address.pincode,
      address.country?.countryname
    ].filter(Boolean).join(', ');
  };

  const getStatusBadge = (status) => {
    switch (status) {
      case 'Draft': return 'secondary';
      case 'Submitted': return 'primary';
      case 'Approved': return 'success';
      case 'Rejected': return 'danger';
      case 'Completed': return 'info';
      case 'Open': return 'warning';
      case 'Active': return 'success';
      case 'Cancelled': return 'danger';
      default: return 'light';
    }
  };

  if (isLoading) {
    return (
      <div className="d-flex justify-content-center align-items-center" style={{ height: "100vh" }}>
        <Spinner animation="border" variant="primary" />
      </div>
    );
  }

  if (!salesOrderData) {
    return <div className="alert alert-danger text-center mt-4">Sales Order not found</div>;
  }

  // Calculations
  const nettotalinr = rows.reduce((sum, row) => sum + (parseFloat(row.totalInr) || 0), 0);
  const nettotalcurrency = rows.reduce((sum, row) => sum + (parseFloat(row.totalcurrency) || 0), 0);
  const exportChargesINR = (salesOrderData.exportpreperationchargescurrency || 0) * (salesOrderData.soexchangerate || 0);
  const grandtotalinr = (salesOrderData.grandtotalinr || nettotalinr + exportChargesINR);
  const grandtotalcurrency = (salesOrderData.grandtotalcurrency || nettotalcurrency + (salesOrderData.exportpreperationchargescurrency || 0));

  return (
    <Container fluid className="p-3">
      {/* Header Section */}
      <div className="shadow-sm border rounded bg-white mb-3">
        <div className="p-3">
          <div className="d-flex justify-content-between align-items-center mb-2">
            <h5 className="fw-bold text-primary mb-0">PUMP INTERNATIONAL SALES ORDER - VIEW</h5>
            <div>
              <Button variant="secondary" size="sm" onClick={() => navigate(-1)}>
                <FaArrowLeft className="me-1" />
                Back
              </Button>
            </div>
          </div>

          <Row className="g-2">
            <Col md={3}>
              <div className="border-start border-3 border-primary ps-2">
                <small className="text-muted">SO Number</small>
                <div className="fw-bold">{salesOrderData.sono || '-'}</div>
              </div>
            </Col>
            <Col md={3}>
              <div className="border-start border-3 border-success ps-2">
                <small className="text-muted">SO Date</small>
                <div className="fw-bold">{formatDate(salesOrderData.sodate)}</div>
              </div>
            </Col>
            <Col md={3}>
              <div className="border-start border-3 border-warning ps-2">
                <small className="text-muted">Currency</small>
                <div className="fw-bold">{salesOrderData.salesordercurrency || '$ (USD)'}</div>
              </div>
            </Col>
            <Col md={3}>
              <div className="border-start border-3 border-info ps-2">
                <small className="text-muted">Status</small>
                <div>
                  <Badge bg={getStatusBadge(salesOrderData.status)} className="px-2 py-1">
                    {salesOrderData.status || '-'}
                  </Badge>
                </div>
              </div>
            </Col>
          </Row>
        </div>
      </div>

      {/* Branch & Warehouse */}
      <div className="shadow-sm border rounded bg-white mb-3">
        <div className="bg-light py-2 px-3 border-bottom">
          <h6 className="mb-0 fw-bold">Branch & Warehouse Details</h6>
        </div>
        <div className="p-3">
          <Row className="g-3">
            <Col md={6}>
              <small className="text-muted">Branch</small>
              <div className="fw-bold">{salesOrderData.branch?.branchname || '-'}</div>
            </Col>
            <Col md={6}>
              <small className="text-muted">Warehouse</small>
              <div className="fw-bold">{salesOrderData.warehouse?.warehousename || '-'}</div>
            </Col>
          </Row>
        </div>
      </div>

      {/* Sales Order Details */}
      <div className="shadow-sm border rounded bg-white mb-3">
        <div className="bg-light py-2 px-3 border-bottom">
          <h6 className="mb-0 fw-bold">Sales Order Details</h6>
        </div>
        <div className="p-3">
          <Row className="g-3">
            <Col md={4}>
              <small className="text-muted">Quotation No</small>
              <div className="fw-bold">{salesOrderData.quotationno || '-'}</div>
            </Col>
            <Col md={4}>
              <small className="text-muted">Quotation Date</small>
              <div className="fw-bold">{formatDate(salesOrderData.quotationdate)}</div>
            </Col>
            <Col md={4}>
              <small className="text-muted">Exchange Rate (₹/Currency)</small>
              <div className="fw-bold">{salesOrderData.soexchangerate || '0.00'}</div>
            </Col>
            <Col md={4}>
              <small className="text-muted">Customer PO No</small>
              <div className="fw-bold">{salesOrderData.customerpono || '-'}</div>
            </Col>
            <Col md={4}>
              <small className="text-muted">Customer PO Date</small>
              <div className="fw-bold">{formatDate(salesOrderData.customerpodate)}</div>
            </Col>
            <Col md={4}>
              <small className="text-muted">Payment Term</small>
              <div className="fw-bold">{salesOrderData.paymentterm || '-'}</div>
            </Col>
            <Col md={4}>
              <small className="text-muted">Incoterms</small>
              <div className="fw-bold">{salesOrderData.incoterm || '-'}</div>
            </Col>
          </Row>
        </div>
      </div>

      {/* Customer Information */}
      <div className="shadow-sm border rounded bg-white mb-3">
        <div className="bg-light py-2 px-3 border-bottom">
          <h6 className="mb-0 fw-bold">Customer Information</h6>
        </div>
        <div className="p-3">
          <Row className="g-3">
            <Col md={4}>
              <small className="text-muted">Company Name</small>
              <div className="fw-bold">{salesOrderData.customer?.companyname || '-'}</div>
            </Col>
            <Col md={4}>
              <small className="text-muted">Contact Person</small>
              <div className="fw-bold">{salesOrderData.contactperson || '-'}</div>
            </Col>
            <Col md={4}>
              <small className="text-muted">GST No</small>
              <div className="fw-bold">{salesOrderData.customer?.gstno || '-'}</div>
            </Col>
            <Col md={4}>
              <small className="text-muted">Phone</small>
              <div className="fw-bold">{salesOrderData.contactno || '-'}</div>
            </Col>
            <Col md={4}>
              <small className="text-muted">Email</small>
              <div className="fw-bold">{salesOrderData.email || '-'}</div>
            </Col>
            <Col md={12}>
              <small className="text-muted">Address</small>
              <div className="fw-bold">{getAddressString(salesOrderData.customeraddress)}</div>
            </Col>
          </Row>
        </div>
      </div>

      {/* Sales Order Items */}
      <div className="shadow-sm border rounded bg-white mb-3">
        <div className="bg-light py-2 px-3 border-bottom">
          <h6 className="mb-0 fw-bold">Sales Order Items</h6>
        </div>
        <div className="p-0">
          <div className="table-responsive">
            <Table bordered size="sm" className="mb-0">
              <thead className="table-light">
                <tr>
                  <th className="text-center fw-bold py-2">#</th>
                  <th className="fw-bold py-2">Description</th>
                  <th className="fw-bold py-2">Part No</th>
                  <th className="fw-bold py-2">HSN Code</th>
                  <th className="fw-bold py-2">Serial No</th>
                  <th className="fw-bold py-2">Model No</th>
                  <th className="fw-bold py-2">Tag No</th>
                  <th className="fw-bold py-2">MOC</th>
                  <th className="fw-bold py-2">Item Code</th>
                  <th className="fw-bold py-2 text-center">Qty</th>
                  <th className="fw-bold py-2 text-center">UOM</th>
                  <th className="fw-bold py-2 text-end">Unit Rate (Curr)</th>
                  <th className="fw-bold py-2 text-end">Total (Curr)</th>
                  <th className="fw-bold py-2 text-end">Unit Rate (₹)</th>
                  <th className="fw-bold py-2 text-end">Total (₹)</th>
                </tr>
              </thead>
              <tbody>
                {rows.map((row, index) => (
                  <tr key={index}>
                    <td className="text-center">{index + 1}</td>
                    <td>
                      <div className="fw-semibold">{row.description || '-'}</div>
                      {row.productremarks && row.productremarks !== '-' && (
                        <div className="text-muted small mt-1">
                          <small><strong>Remarks:</strong> {row.productremarks}</small>
                        </div>
                      )}
                    </td>
                    <td>{row.partno || '-'}</td>
                    <td>{row.hsnsacno || '-'}</td>
                    <td>{row.serialnumber || '-'}</td>
                    <td>{row.modelnumber || '-'}</td>
                    <td>{row.tagnumber || '-'}</td>
                    <td>{row.moc || '-'}</td>
                    <td>{row.itemcode || '-'}</td>
                    <td className="text-center">{row.quantity || '0'}</td>
                    <td className="text-center">{row.uom || '-'}</td>
                    <td className="text-end">{formatNumber(row.unitratecurrency)}</td>
                    <td className="text-end">{formatNumber(row.totalcurrency)}</td>
                    <td className="text-end">{formatCurrency(row.unitRateInr)}</td>
                    <td className="text-end fw-semibold">{formatCurrency(row.totalInr)}</td>
                  </tr>
                ))}
              </tbody>
            </Table>
          </div>
        </div>
      </div>

      {/* Calculation Summary */}
      <Row>
        <Col lg={6} className="ms-auto">
          <div className="shadow-sm border rounded bg-white">
            <div className="bg-light py-2 px-3 border-bottom">
              <h6 className="mb-0 fw-bold text-center">Amount Calculation</h6>
            </div>
            <div className="p-3">
              <div className="d-flex justify-content-between align-items-center py-1 border-bottom">
                <span className="fw-semibold">Net Total (INR):</span>
                <span className="fw-bold">{formatCurrency(nettotalinr)}</span>
              </div>
              <div className="d-flex justify-content-between align-items-center py-1 border-bottom">
                <span className="fw-semibold">Net Total (Currency):</span>
                <span className="fw-bold">{formatNumber(nettotalcurrency)}</span>
              </div>
              <div className="d-flex justify-content-between align-items-center py-1 border-bottom">
                <span className="fw-semibold">Export Charges (Currency):</span>
                <span className="fw-bold">{formatNumber(salesOrderData.exportpreperationchargescurrency)}</span>
              </div>
              <div className="d-flex justify-content-between align-items-center py-1 border-bottom">
                <span className="fw-semibold">Export Charges (INR):</span>
                <span className="fw-bold">{formatCurrency(exportChargesINR)}</span>
              </div>
              <div className="d-flex justify-content-between align-items-center py-2 border-top">
                <span className="fw-bold">Grand Total (INR)</span>
                <span className="fw-bold text-primary">{formatCurrency(grandtotalinr)}</span>
              </div>
              <div className="d-flex justify-content-between align-items-center py-2">
                <span className="fw-bold">Grand Total (Currency)</span>
                <span className="fw-bold text-success">{formatNumber(grandtotalcurrency)}</span>
              </div>
            </div>
          </div>
        </Col>
      </Row>

      {/* Footer Actions */}
      <div className="text-center mt-3 pt-2 border-top">
        <Button
          variant="secondary"
          size="sm"
          onClick={() => navigate("/salesOrderIndexTable/1")}
        >
          <FaArrowLeft className="me-1" />
          Back to List
        </Button>
      </div>
    </Container>
  );
};

export default ViewPumpInternationalSalesOrder;